
export const extractTypeFromLayerId = (id) => {
  const parts = id.split('-');
  if (parts.length >= 2) {
    return parts[1];
  }
  return null;
};

// export const extractTitleFromUrl = (assetUrl, excludeExt = true) => {
//   // Extract the title from assetUrl
//   let title = assetUrl ? assetUrl.split('/').pop() : null;
//   if (excludeExt) {
//     if (title && title.includes('.')) {
//       title = title.substring(0, title.lastIndexOf('.'));
//     }
//   }
//   return title
// }

export const extractTitleFromUrl = (assetUrl, excludeExt = true) => {
  if (!assetUrl) return null;

  // Split the URL into parts
  const parts = assetUrl.split('/');

  // Remove any empty segments that might result from trailing slashes
  const filteredParts = parts.filter(part => part !== '');

  // Determine if the last path segment is 'content', adjust index accordingly
  let title = filteredParts[filteredParts.length - (filteredParts[filteredParts.length - 1] === 'content' ? 2 : 1)];

  // Optionally remove the file extension from the title
  if (excludeExt && title.includes('.')) {
    title = title.substring(0, title.lastIndexOf('.'));
  }

  return title;
}

export const extractUUIDFromLayerId = (id) => {
  const parts = id.split('-');
  if (parts.length >= 2) {
    return parts[2];
  }
  return null;
};

export const getCircleLayerRadiusProperty = (value = 2.2) => {
  return [
    "interpolate",
    ["exponential", 2],
    ["zoom"],
    0, 0, // At zoom level 0, the circle radius is 0 pixels
    21, ['*', 27, ["^", value, 2]] // At zoom level 21, the circle radius is calculated as 27 times the square of the value
  ];
}

export const getCircleLayerOpacityProperty = (opacityOnHover = 1, opacity = 0.8) => {
  return [
    'case',
    ['boolean', ['feature-state', 'hover'], false],
    opacityOnHover,     // default is 1 on hover effect
    opacity             // default is 0.8
  ];
}

export const extractCircleRadiusFromLayerPaintProperty = (radiusProperty) => {
  try {
    const radiusValue = radiusProperty[radiusProperty.length - 1][2];
    return Array.isArray(radiusValue) ? radiusValue[1] : Math.sqrt(radiusValue);
  } catch (err) {
    console.error("Error extracting circle radius from a circlelayer paint property");
    return null;
  }
}

export const extractCircleOpacityFromLayerPaintProperty = (opacityProperty) => {
  try {
    return { opacityOnHover: opacityProperty[2], opacity: opacityProperty[3] };
  } catch (err) {
    console.error("Error extracting circle opacity from a circlelayer paint property");
    return null;
  }
}

export const extractSgeTypeFilterFromLayerProperty = (filter) => {
  try {
    let sgeToggleStates = [
      { type: "Gene", checked: false },
      { type: "GeneFull", checked: false },
      { type: "VelocytoAmbiguous", checked: false },
      { type: "VelocytoSpliced", checked: false },
      { type: "VelocytoUnspliced", checked: false }
    ];
    filter && filter.forEach((f) => {
      if (Array.isArray(f) && f.length > 1 && Array.isArray(f[1]) && f[1].length > 1 && Array.isArray(f[1][1]) && f[1][1].length > 1) {
        const type = f[1][1][1];
        // set according checked field true if the type name exists
        const state = sgeToggleStates.find(state => state.type === type);
        if (state) {
          state.checked = true;
        }
      }
    });
    return sgeToggleStates;
  } catch (err) {
    console.error("Error extracting SGE type filter from a circlelayer paint property");
    return null;
  }
}

export const extractColormapFromFictureLayer = (map, layerId) => {
  try {
    const sourceId = map.current.getLayer(layerId).source;
    const sourceConfig = map.current.getStyle().sources[sourceId];
    const url = sourceConfig.tiles[0];
    const queryParams = url.split("?");
    const colormap = queryParams && Array.isArray(queryParams) && queryParams.length > 0 && queryParams[1].split("&")?.[1];
    return colormap ? JSON.stringify(JSON.parse(decodeURIComponent(colormap.replace("colormap=", "")))) : null;
  } catch (err) {
    console.error("Error extracting colormap from a ficture layer");
    return null;
  }
}
